<template>
  <div>
    <BaseTitle :title="$t(edit ? 'content.edit_pages' : 'content.add_pages')" :yearPeriode="titleData" />
    <v-row>
      <v-col cols="12" md="12">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <form-group :name="$t('content.title')" :validator="$v.form.title">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.title"
                    :disabled="isEditable"
                    v-bind="attrs"
                    :label="$t('content.title')"
                    @input="$v.form.title.$touch()"
                    @blur="$v.form.title.$touch()"
                  />
                </template>
              </form-group>
              <div class="app-section-title mb-6">{{ $t('content.content_pages') }}</div>
              <form-group>
                <template slot-scope="{ attrs }">
                  <text-editor v-bind="attrs" v-model="form.content" />
                </template>
              </form-group>

              <div v-if="form.content" class="app-section-title mb-5">{{ $t('content.preview') }}</div>
              <div v-if="form.content" style="border: 1px solid #d8d8d8; border-radius: 8px 8px 8px 8px;" class="pa-5">
                <article v-if="form.content" v-html="form.content" />
                <span v-else>-</span>
              </div>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" @click="submit" :loading="loading">
              {{ $t('submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextEditor from '@/components/base/TextEditor.vue';
import BaseTitle from '@/components/base/Title';
import { required, maxLength } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
export default {
  name: 'CreateEditPages',
  components: {
    BaseTitle,
    TextEditor
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      form: {
        title: { required, maxLength: maxLength(255) },
        content: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      tokenBearer: 'Auth/token',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    form: {
      title: '',
      content: ''
    },
    loadingButton: false,
    dataClass: '',
    loading: false,
    edit: false,
    titleData: ''
  }),
  methods: {
    getData() {
      this.$store.dispatch('Pages/fetchDetail', this.$route.params.id).then(ras => {
        Object.keys(this.form).forEach(form => {
          this.form[form] = ras[form];
        });
      });
    },
    getDataClass() {
      this.$store
        .dispatch('Class/fetchClassroomCourseName', {
          classId: this.$route.params.classId,
          courseId: this.$route.params.courseId
        })
        .then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res + ` ( ${resa.yearPeriode} ) `;
            });
          } else {
            this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
    },
    getClassLevel() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse');
    },
    submit() {
      if (!this.form.content) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_form_content_pages') });
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      const input = {
        title: this.form.title,
        content: this.form.content,
        classroomId: this.$route.params.classId,
        classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
        courseId: this.$route.params.courseId
      };

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...input };

      this.$store
        .dispatch(`Pages/${this.edit ? 'update' : 'save'}`, payload)
        .then(() =>
          this.$router.push({
            name:
              this.edit && !this.$route.params.classSectionId
                ? 'PagesTeacherUpdateSuccess'
                : !this.edit && !this.$route.params.classSectionId
                ? 'PagesTeacherSuccess'
                : this.edit && this.$route.params.classSectionId
                ? 'PagesSectionTeacherUpdateSuccess'
                : 'PagesSectionTeacherSuccess'
          })
        )
        .finally(() => (this.loading = false));
    },
    back() {
      if (this.isClass && !this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'PagesIndexClass' });
        } else {
          this.$router.push({ name: 'PagesSectionIndexClass' });
        }
      } else if (this.isClass && this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'PagesStudentIndexClass' });
        } else {
          this.$router.push({ name: 'PagesStudentSectionIndexClass' });
        }
      } else {
        this.$router.push({ name: 'PagesIndex' });
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.getData();
      this.edit = true;
    }
    if (this.isClass) {
      this.getDataClass();
    } else {
      this.getClassLevel();
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
</style>
